// List of users allowed to view the Incidents Bowler.
// Add lowercase email addresses here, one per entry.
// If the list is empty, access is not restricted.
const ALLOWED_BOWLER_USERS: string[] = [];

export default ALLOWED_BOWLER_USERS;
